import { all } from "redux-saga/effects";
import user from "./user";
import home from "./home";
import contests from './contests';
import auth from './auth';
import common from "./common";
import explore from "./explore";
import enrollContest from "./enrollContest";
import contestProfile from "./contestProfile";
import applyToJudge from "./applyToJudge";
import hostProfile from "./hostProfile";
import search from "./search";
import notification from "./notification"
import singleMedia from "./singleMedia"
export default function* rootSaga(getState) {
    yield all([
        user(),
        home(),
        contests(),
        auth(),
        common(),
        explore(),
        enrollContest(),
        contestProfile(),
        applyToJudge(),
        hostProfile(),
        search(),
        notification(),
        singleMedia()
    ]);
}